import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { Language } from '../layout/api/language';

@Injectable({
  providedIn: 'root',
})
export class I18nService {
  translate = inject(TranslateService);

  public idioma: BehaviorSubject<Language> = new BehaviorSubject({
    code: '',
  });

  public paises: Language[] = [
    { code: 'pt' },
    { code: 'en' },
  ];
  constructor() {
    this.I18n();
  }

  public I18n() {
    const browserLang = this.translate.getBrowserLang() ?? 'pt';
    this.translate.use(browserLang.match(/pt|en/) ? browserLang : 'pt');
    if (browserLang === 'pt') {
      this.idioma.next(this.paises[0]);
    } else {
      this.idioma.next(this.paises[1]);
    }
  }
}
